/* eslint-disable arrow-body-style */
/* eslint-disable @typescript-eslint/no-use-before-define */
import {
  CollectionReturnValue,
  Core,
  NodeSingular,
  SearchDijkstraResult,
} from 'cytoscape';
import { findPathsBetween } from './cyFindAllPaths';
import { cyHasMultiplePaths } from './cyHasMultiplePaths';

interface InitProps {
  cy: Core;
  sourceNodeId: string;
  setHighlightedPaths: (paths: string) => void;
}

interface SearchProps {
  cy: Core;
  searchValue: string;
}

export const cyHighlightPaths = cyHighlightUtil();

function cyHighlightUtil() {
  let dijkstra: SearchDijkstraResult | null = null;
  let sourceNode: CollectionReturnValue | null = null;
  let setHighlightedItems: (paths: string) => void = () => {};

  return {
    init,
    highlightPaths,
    clear,
  };

  function init({ cy, sourceNodeId, setHighlightedPaths }: InitProps) {
    setHighlightedItems = setHighlightedPaths;
    const cyElements: CollectionReturnValue = cy.elements();
    sourceNode = cy.$id(sourceNodeId);

    dijkstra = cyElements.dijkstra({
      root: sourceNode,
      directed: false,
    });
  }

  function highlightPaths({ cy, searchValue }: SearchProps) {
    if (searchValue.trim() === '') {
      clear(cy);
      return;
    }

    const cyElements: CollectionReturnValue = cy.elements();
    const lowerSearch = searchValue.trim().toLowerCase();

    const matchingNodes = cy
      .elements()
      .nodes()
      .filter((n) => {
        const value = n.data('value') as string;
        return value.toLowerCase() === lowerSearch;
      });

    if (matchingNodes.length === 0) {
      fade(cyElements);
      setHighlightedItems('');
      return;
    }

    const paths = getPathsToTargets(cy, sourceNode!, matchingNodes);
    fade(cyElements);
    unFade(paths);
    setHighlightedItems(
      Array.from(new Set(paths.map((n) => n.id())))
        .sort()
        .join(',')
    );
  }

  function clear(cy: Core) {
    unFade(cy.elements());
    setHighlightedItems('');
  }

  function fade(items: CollectionReturnValue) {
    items.addClass('fade');
  }

  function unFade(items: CollectionReturnValue) {
    items.removeClass('fade');
  }

  function getPathsToTargets(
    cy: Core,
    source: CollectionReturnValue,
    targets: CollectionReturnValue
  ): CollectionReturnValue {
    const hasMultiplePaths = cyHasMultiplePaths({
      source,
      targets,
    });

    if (hasMultiplePaths) {
      return findPathsBetween({
        cy,
        source,
        targets,
      });
    }

    return targets.reduce((acc, targetNode) => {
      const path = dijkstra!.pathTo(targetNode as NodeSingular);
      return acc.union(path);
    }, sourceNode!);
  }
}
